<template>
  <div>
    <div class="title-and-search">
      <div class="row">
        <div class="blocheader-wrapper single-title-wrapper col-12">
          <div class="row">
            <div class="button-box col-3 clear-side-padding">
              <toolbar
                @openSelectionTemplate="handleOpenSelectionTemplate"
                @openSelectionFicheModal="handleOpenSelectionFicheModal"
                @openExportModal="handleOpenExportFicheModal"
                @saveChanges="handleSaveChanges"
                @exitEditMode="handleExitEditMode"
              ></toolbar>
            </div>
            <div class="button-box col-9 clear-side-padding">
              <div class="btn-toolbar">
                <rightToolbar></rightToolbar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <loading v-if="isLoadingFicheEspaces()" />
        <list-tableau-colonne
          v-else-if="!isLoadingFicheEspaces() && ficheData"
          :data="ficheData"
        >
        </list-tableau-colonne>
      </div>
      <div class="col-9">
        <loading v-if="isLoadingFicheData()" />
        <ficheEspaceContentEdit
          style="height: calc(100vh - 150px); overflow-y: auto;"
          v-else-if="!isLoadingFicheData() && data"
          :fiche="data"
        >
        </ficheEspaceContentEdit>
      </div>
    </div>
    <selection-structure @apply="handleApplyTemplate" ref="selectionModal" />
    <selection-espace @apply="handleApplyStructure" ref="selectionFicheModal" />
    <export-fiche
      @apply="handleApplyExportFiche"
      :is-export="isExportingFiche"
      ref="exportFicheModal"
    ></export-fiche>
  </div>
</template>

<script>

import ficheEspaceContentEdit from '../../components/ficheEspace/edit/ficheEspaceContentEdit'
import listTableauColonne from '../../components/ficheEspace/edit/listTableauColonne'
import { mapGetters, mapActions } from 'vuex'
import toolbar from '../../components/ficheEspace/edit/toolbar'
import selectionStructure from '../../components/ficheEspace/modal/selectionStructure'
import loading from '../../components/loading'
import selectionEspace from '../../components/ficheEspace/modal/selectionEspace'
import exportFiche from '../../components/ficheEspace/modal/exportFiche'
import {EventBus, events} from '../../eventBus'
import rightToolbar from '../../components/ficheEspace/edit/rightToolbar'
import axios from 'axios'
import { ENTRYPOINT } from '../../config/entrypoint'
export default {
  components: {
    ficheEspaceContentEdit,
    listTableauColonne,
    toolbar,
    selectionStructure,
    loading,
    selectionEspace,
    exportFiche,
    rightToolbar
  },
  data () {
    return {
      data: null,
      ficheData: null,
      hasModification: false,
      isExportingFiche: false,
      isEditable: null
    }
  },
  computed: {
    ...mapGetters(['currentFicheData', 'getFicheInfo', 'templatesFiche'])
  },
  methods: {
    ...mapGetters(['isProjectTemplate', 'isLoadingFicheData', 'droppedHeaders', 'deletedHeaders', 'currentFiche', 'currentProject', 'isLoadingFicheEspaces']),
    ...mapActions(['setMessage', 'exportFicheEspace', 'updateFicheTemplate', 'saveFicheEspace', 'exportAllFicheEspace', 'applyTemplateFiche', 'applyStructureFiche', 'overwriteDroppedHeader', 'setAddedToFiche', 'overwriteDeletedHeader', 'setCurrentFiche', 'setLastFiche', 'loadFiche', 'getFicheTableauData', 'setCurrentProject', 'loadTemplateData', 'setSaving']),
    async saveConfirm (currMod, next) {
      if (currMod === 'FDE') {
        await this.handleSaveChanges()
        next()
      }
    },
    async handleSaveChanges () {
      var exportHtml = document.getElementById('panel-fiche').outerHTML

      // axios({ url: ENTRYPOINT + '/api/fiche-espace/savehtml/' + this.currentFicheData.id, data: {html: exportHtml}, method: 'POST' })

      if (this.isProjectTemplate()) {
        this.setSaving(true)
        await this.updateFicheTemplate(this.currentFicheData)
        this.hasModification = false
        EventBus.$emit(events.HAS_MODIFICATION, false)
        this.setSaving(false)
      } else {
        this.setSaving(true)
        this.overwriteDroppedHeader([])
        this.overwriteDeletedHeader([])
        await this.saveFicheEspace(this.currentFicheData)
        this.hasModification = false
        EventBus.$emit(events.HAS_MODIFICATION, false)
        this.setSaving(false)
      }
      this.setMessage('Sauvegardé')
    },
    handleExitEditMode () {
      if (this.hasModification) {
        this.$bvModal.msgBoxConfirm(`Voulez-vous sauvegarder vos modifications ?`, {
          modalClass: 'base-modal save-popup',
          'dialog-class': 'myDialog',
          title: 'Sauvegarde de fiche',
          buttonSize: 'sm',
          headerClass: 'bg-primary',
          okVariant: 'outline-primary',
          okTitle: 'Sauvegarder',
          cancelVariant: 'outline-danger',
          cancelTitle: 'Quitter sans sauvegarder',
          footerClass: 'p-2',
          hideHeaderClose: false
        })
          .then(async value => {
            if (value) {
              await this.handleSaveChanges()
            }
            if (typeof this.$route.params.tokenInvite !== 'undefined' && this.$route.params.tokenInvite !== '') {
              if (this.isProjectTemplate()) {
                this.$router.push({ path: `/invite/templates-fiches/${this.currentProject()}/${this.$route.params.idInvitation}/${this.$route.params.tokenInvite}` })
              } else {
                this.$router.push({ path: `/invite/fiches-espaces/${this.currentProject()}/${this.$route.params.idInvitation}/${this.$route.params.tokenInvite}` })
              }
            } else {
              if (this.isProjectTemplate()) {
                this.$router.push({ path: `/templates-fiches/${this.currentProject()}` })
              } else {
                this.$router.push({ path: `/fiches-espaces/${this.currentProject()}` })
              }
            }
          })
      } else {
        if (typeof this.$route.params.tokenInvite !== 'undefined' && this.$route.params.tokenInvite !== '') {
          if (this.isProjectTemplate()) {
            this.$router.push({ path: `/invite/templates-fiches/${this.currentProject()}/${this.$route.params.idInvitation}/${this.$route.params.tokenInvite}` })
          } else {
            this.$router.push({ path: `/invite/fiches-espaces/${this.currentProject()}/${this.$route.params.idInvitation}/${this.$route.params.tokenInvite}` })
          }
        } else {
          if (this.isProjectTemplate()) {
            this.$router.push({ path: `/templates-fiches/${this.currentProject()}` })
          } else {
            this.$router.push({ path: `/fiches-espaces/${this.currentProject()}` })
          }
        }
      }
    },
    handleOpenSelectionTemplate () {
      this.$refs['selectionModal'].open(this.templatesFiche)
    },
    handleOpenSelectionFicheModal () {
      this.$refs['selectionFicheModal'].open()
    },
    handleApplyTemplate (data) {
      this.applyTemplateFiche(data)
    },
    async handleApplyStructure (selected) {
      const res = await this.applyStructureFiche({ selected, data: this.data })
      this.setMessage(res)
    },
    handleOpenExportFicheModal () {
      this.$refs['exportFicheModal'].open()
    },
    async handleApplyExportFiche (idexp) {
      if (this.hasModification) {
        this.isExportingFiche = true
        await this.handleSaveChanges()
      }

      if (idexp === 1) {
        this.isExportingFiche = true
        await this.exportFicheEspace({ onglet: this.currentFicheData.onglet, ligne: this.currentFicheData.ligne })
        this.isExportingFiche = false
      } else if (idexp === 0) {
        this.isExportingFiche = true
        await this.exportAllFicheEspace(this.currentProject())
        this.isExportingFiche = false
      }
    },
    checkChanged (oldValue, newValue) {
      return JSON.stringify(oldValue) === JSON.stringify(newValue)
    }
  },
  watch: {
    currentFicheData: {
      handler (newValue) {
        if (this.data) {
          this.hasModification = this.checkChanged(this.data, newValue)
          EventBus.$emit(events.HAS_MODIFICATION, this.hasModification)
        }
        this.data = { ...newValue }
      },
      deep: true
    },
    getFicheInfo: {
      handler (newValue) {
        // if (!this.isProjectTemplate()) {
        this.ficheData = { ...newValue }
        // }
      },
      deep: true
    }
  },
  async created () {
    const idProject = this.$route.params.idProject
    const idFiche = this.$route.params.idFiche
    this.setCurrentFiche(idFiche)
    this.setCurrentProject(idProject)

    if (!this.currentFicheData) {
      if (!this.isProjectTemplate()) {
        await Promise.all([this.loadFiche(idFiche), this.getFicheTableauData(idProject)])
      } else {
        await Promise.all([this.loadTemplateData(idFiche), this.getFicheTableauData(idProject)])
      }
    }
  },
  mounted () {
    EventBus.$on(events.SAVE_CONFIRM, this.saveConfirm)
  },
  beforeMount () {
    if (!this.data) {
      this.data = { ...this.currentFicheData }
    }
    if (!this.ficheData) {
      this.ficheData = { ...this.getFicheInfo }
    }
  },
  beforeDestroy () {
    if (!this.isProjectTemplate()) {
      let actions = []

      if (this.droppedHeaders().length) {
        actions = [...actions, ...this.droppedHeaders().map(el => ({ key: el, value: false }))]
      }
      if (this.deletedHeaders().length) {
        actions = [...actions, ...this.deletedHeaders().map(el => ({ key: el, value: true }))]
      }

      const revertActions = actions.reduce((acc, curr) => {
        if (acc[curr.key] != null) {
          delete acc[curr.key]
          return acc
        }
        acc[curr.key] = curr.value
        return acc
      }, {})

      Object.keys(revertActions).forEach(key => {
        this.setAddedToFiche({ headerKey: key, value: revertActions[key] })
      })

      this.overwriteDeletedHeader([])
      this.overwriteDroppedHeader([])
    }

    EventBus.$off(events.SAVE_CONFIRM, this.saveConfirm)
  }
}
</script>
<style lang="scss" scoped>
.blocheader-wrapper.single-title-wrapper {
  /*height: 120px;*/
}

</style>



// WEBPACK FOOTER //
// src/pages/pageEditFicheEspace/index.vue